const MAX_SELECT_HEIGHT = 160;
const MIN_SCROLLED_OPTIONS_NUMBER = 4;
const OPTION_HEIGHT = 40;
const SELECT_TOP_BOTTOM_PADDINGS_SUM = 16;

export const getSelectOptionsHeight = (
  optionsAmount: number,
  withSearch: boolean
) => {
  const paddings = withSearch ? 0 : SELECT_TOP_BOTTOM_PADDINGS_SUM;

  return optionsAmount >= MIN_SCROLLED_OPTIONS_NUMBER
    ? `${MAX_SELECT_HEIGHT + paddings}px`
    : `${optionsAmount * OPTION_HEIGHT + paddings}px`;
};
